import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export const SilentModeWarning = () => {
  const { t } = useTranslation();

  // we want to show this popup after 2seconds
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => setShowPopup(true), 2000);
  }, []);

  return (
    <Dialog open={showPopup} onOpenChange={() => setShowPopup(!showPopup)}>
      <DialogContent
        className="w-11/12 max-w-[425px] bg-primary py-10 text-center sm:w-full"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDown={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="pb-6">
            {t('silent_mode.warning.title')}
          </DialogTitle>
          <DialogDescription>
            {t('silent_mode.warning.description')}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button
            type="submit"
            onClick={() => setShowPopup(false)}
            variant="secondary"
          >
            {t('silent_mode.warning.button')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
